import { fmtDate, publicDdtUrl } from "@/lib/api";
import { BRAND, waLink } from "@/lib/brand";

export const ddtClientWa = (d) =>
  waLink(d.cliente_telefono, `Gentile ${d.cliente_nome || "cliente"}, le inviamo il documento di trasporto n. ${d.numero} del ${fmtDate(d.data)}.\nPuò scaricarlo qui: ${publicDdtUrl(d.share_token)}\n\n${BRAND.name} – ${BRAND.phone}`);

export const ddtVetWa = (d, phone) =>
  waLink(phone, `Buongiorno, è disponibile il documento di trasporto n. ${d.numero} del ${fmtDate(d.data)}.\nScaricabile dalla vostra area riservata o qui: ${publicDdtUrl(d.share_token)}\n\n${BRAND.name}`);
